import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './app/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Add font classes to body
document.body.className = 'font-sans antialiased'

